import { useState } from "react";
import AddCrewRoleModal from "src/components/pages/Management/CrewRoles/AddCrewRoleModal";
import ManagementSearch from "src/components/pages/Management/ManagementSearch/ManagementSearch";
import ManagementTable from "src/components/pages/Management/ManagementTable/ManagementTable";
import { useIsSuperAdmin } from "src/components/pages/Management/useIsSuperAdmin";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { Button } from "src/components/shared/Button/Button";
import { useGetApi } from "src/hooks";
import { ButtonsWrapper, Flex, PageContainer } from "src/styled";

import { type ICrewRole } from "./CrewRoles.types";

const mapRoles = (data: any) => data?.data?.content as { list: ICrewRole[] };

const CrewRoles = () => {
  const [open, setOpen] = useState(false);

  const isSuperAdmin = useIsSuperAdmin();
  const requestBody = { _sect: "_roles" };
  const { data, isLoading, refetch } = useGetApi({
    request: "get-management",
    body: requestBody,
    mapper: mapRoles,
  });

  return (
    <PageContainer>
      <Breadcrumbs border={false}>
        <ButtonsWrapper>
          {/* Commented out until it is implemented */}
          {isSuperAdmin && <Button onClick={() => setOpen(true)}>Add +</Button>}
        </ButtonsWrapper>
      </Breadcrumbs>
      <Flex justify="end" mb={15} mt={10}>
        <ManagementSearch
          section="_roles"
          refetch={refetch}
          currentRequestParams={requestBody}
        />
      </Flex>
      <ManagementTable
        section="_roles"
        data={data?.list ?? []}
        loading={isLoading}
      />
      <AddCrewRoleModal opened={open} onClose={() => setOpen(false)} />
    </PageContainer>
  );
};

export default CrewRoles;
